import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../../components/button/button";

import ContactsContainer from "./contacts-container";

// import "./NavigationItems.css";
import "./contacts.css";

function ContactsItems(props) {
  return (
    <li>
      <div className="contact-item">
        <div className="contact">
          <h3>{props.type}: </h3> <a href={`${props.link}`}>{props.name}</a>
        </div>
        <div>
          {props.isAuth && (
            <>
              <Button design="flat" mode="danger" onClick={props.onDelete}>
                Delete
              </Button>
              <Button design="flat" onClick={props.onStartEdit}>
                Edit
              </Button>
            </>
          )}
        </div>
      </div>
    </li>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default ContactsItems;
